import * as jsxRuntime from "C:\\Eido-projects\\demo-lead-tool-3.0\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment